import { PiCheckCircle } from 'react-icons/pi';
import { DocumentOverviewCapTableRow } from './colDefsDocumentOverviewCapTable';

export const ShareholderCell = (props: {
  data: DocumentOverviewCapTableRow;
}) => {
  return (
    <div
      className={`flex items-center gap-2 align-items-center`}
      onClick={(e) => {
        e.preventDefault();
        props.data.scrollToHighlight(props.data.shareholderId);
      }}
    >
      <PiCheckCircle
        className={
          props.data.approvedBy === null ? 'text-yellow-500' : 'text-green-600'
        }
      />
      {props.data.shareholder}
    </div>
  );
};
